export const service = "本协议是数秦科技与用户之间，就数秦科技提供的服务及其相关事宜所订立的契约。请认真阅读本协议。用户同意本协议并继续使用数秦科技的服务，本协议即对双方具有法律约束力。一．总则数秦科技在此特别提醒您（用户）在注册成为用户之前，请认真阅读本《用户协议》（以下简称“协议”），确保您充分理解本协议中各条款。请您审慎阅读并选择接受或不接受本协议。除非您接受本协议所有条款，否则您无权注册、登录或使用本协议所涉服务。您的注册、登录、使用等行为将视为对本协议的接受，并同意接受本协议各项条款的约束。本协议约定数秦科技与用户之间关于数秦科技提供的服务（以下简称“服务”）的权利义务。“用户”是指注册、登录、使用本服务的企业。本协议可由数秦科技随时更新，更新后的协议条款一旦公布即代替原来的协议条款，恕不再另行通知，用户可在本网站查阅最新版协议条款。在数秦科技修改协议条款后，如果用户不接受修改后的条款，请立即停止使用数秦科技提供的服务，用户继续使用数秦科技提供的服务将被视为接受修改后的协议。二、服务内容数秦科技仅提供企业及个人电子数据存储和认证的网络服务，具体内容由数秦科技根据实际情况提供，数秦科技保留随时变更、中断或终止部分或全部服务的权利。三、遵守法律及法律效力1.用户需同意遵守《中华人民共和国保密法》、《计算机信息系统国际联网保密管理规定》、《中华人民共和国计算机信息系统安全保护条例》、《计算机信息网络国际联网安全保护管理办法》、《中华人民共和国计算机信息网络国际联网管理暂行规定》及其实施办法等相关法律法规的任何及所有的规定，并对用户以任何方式使用服务的任何行为及其结果承担全部责任。2.在任何情况下，如果数秦科技合理地认为用户的任何行为，包括但不限于用户的任何言论和其他行为违反或可能违反上述法律和法规的任何规定，数秦科技可在任何时候不经任何事先通知终止向会员提供服务。3.数秦科技可能不时的修改本协议的有关条款，更新后的协议条款一旦公布即代替原来的协议条款，恕不再另行通知且应同现行的使用服务协议一起。4.用户需仔细阅读使用服务协议更改内容，用户由于不知变更内容所带来的伤害，本网站一概不予负责。 如果不同意本网站对服务条款所做的修改，用户有权停止使用网络服务。如果用户继续使用网络服务，则视为用户接受服务条款的变动。四、用户帐号 用户只能按照注册要求使用真实姓名，及身份证号注册。用户有义务保证密码和帐号的安全，用户利用该密码和帐号所进行的一切活动引起的任何损失或损害，由用户自行承担全部责任，本站不承担任何责任。如用户发现帐号遭到未授权的使用或发生其他任何安全问题，应立即修改帐号密码并妥善保管，如有必要，请通知数秦科技。因黑客行为或用户的保管疏忽导致帐号非法使用，本站不承担任何责任。五、隐私保护1.数秦科技不对外公开或向第三方提供单个用户的注册资料及用户在使用网络服务时存储在本站的非公开内容，但下列情况除外：(1)事先获得用户的明确授权；(2)根据有关的法律法规要求；(3)按照相关政府主管部门的要求；(4)为维护社会公众的利益。2.本站可能会与第三方合作向用户提供相关的网络服务，在此情况下，如该第三方同意承担与本站同等的保护用户隐私的责任，则本站有权将用户的注册资料等提供给该第三方。3.在不透露单个用户隐私资料的前提下，本站有权对整个用户数据库进行分析并对用户数据库进行商业上的利用。"

//获取当前可视范围的高度
export const getClientHeight = () => {
  let clientHeight = 0;
  if(document.body.clientHeight && document.documentElement.clientHeight) {
      clientHeight = Math.min(document.body.clientHeight, document.documentElement.clientHeight);
  } else {
      clientHeight = Math.max(document.body.clientHeight, document.documentElement.clientHeight);
  }
  return clientHeight;
}

//获取&&设置-页面垂直滚动值
export const getScrollTop = async (top, time=0) => {
  const range = 150
  top = typeof(top)==='undefined'?'':Number(top)
  if (top || parseInt(top) == 0) { //设置垂直滚动值
    if (self.pageYOffset) {
      let type = self.pageYOffset-top > 0? true:false
      if (time) {
        while(Math.abs(self.pageYOffset-top)>range) {
          await new Promise((resolve) => {
            setTimeout (()=>{
              self.pageYOffset = type?self.pageYOffset-range:self.pageYOffset+range
              resolve()
            }, time)
          })
        }
      }
      self.pageYOffset = top;
    }
    if (document.documentElement && document.documentElement.scrollTop) { // Explorer 6 Strict
      let type = document.body.scrollTop - top > 0? true:false
      if (time) {
        while(Math.abs(document.documentElement.scrollTop - top)>range) {
          await new Promise((resolve) => {
            setTimeout (()=>{
              document.documentElement.scrollTop = type? document.documentElement.scrollTop-range:document.documentElement.scrollTop+range
              resolve()
            }, time)
          })
        }
      }
      document.documentElement.scrollTop = top;  
    }
    if (document.body) {// all other Explorers
      let type = document.body.scrollTop - top > 0? true:false
      if (time) {
        while(Math.abs(document.body.scrollTop - top)>range) {
          await new Promise((resolve) => {
            setTimeout (()=>{
              document.body.scrollTop = type? document.body.scrollTop-range:document.body.scrollTop+range
              resolve()
            }, time)
          })
        }
      } 
      document.body.scrollTop = top;
    }
    return true;
  } else { //获取垂直滚动值
    var yScroll;
    if (self.pageYOffset) {
        yScroll = self.pageYOffset;
    } else if (document.documentElement && document.documentElement.scrollTop) { // Explorer 6 Strict
        yScroll = document.documentElement.scrollTop;
    } else if (document.body) {// all other Explorers
        yScroll = document.body.scrollTop;
    }
    return yScroll;
  }
}

  //获取文档完整的高度
export const getScrollHeight = () => {
  var scrollHeight = 0, bodyScrollHeight = 0, documentScrollHeight = 0;
  if (document.body) {
　　　　bodyScrollHeight = document.body.scrollHeight;
　　}
　　if(document.documentElement){
    documentScrollHeight = document.documentElement.scrollHeight;
　　}
　　scrollHeight = (bodyScrollHeight - documentScrollHeight > 0) ? bodyScrollHeight : documentScrollHeight;
　　return scrollHeight;
}

//时间
export const formatTime = (time, showAll = false, showSFM = false) => {
  function format (value) {
    return Number(value) < 10 ? `0${value}` : value
  }

  let year = new Date(time.replace(/-/g,"/")).getFullYear()
  let month = format(new Date(time.replace(/-/g,"/")).getMonth()+1)
  let day = format(new Date(time.replace(/-/g,"/")).getDate())
  let hour = format(new Date(time.replace(/-/g,"/")).getHours())
  let min = format(new Date(time.replace(/-/g,"/")).getMinutes())
  let seconds = format(new Date(time.replace(/-/g,"/")).getSeconds())
  // hour = hour ? hour : ''
  // min = min ? min : ''
  // seconds = seconds ? seconds : ''
  return !showAll? (!showSFM ? `${year}-${month}-${day}` : `${year}-${month}-${day} ${hour}:${min}:${seconds}`):`${hour}:${min}:${seconds}`

}

//字节转换
export const changeByte = (byte) => {
  let reByte = ''
  if(byte === 0){
    reByte = 0 + 'B'
  }else if(byte < 1024){
    reByte = byte + 'B'
  }else if(byte > 1024){
    let btyeKb = byte/1024
    reByte = parseInt(btyeKb,10) + 'KB'
    if(btyeKb >1024){
      let byteMb = btyeKb/1024
      reByte = parseInt(byteMb,10) + 'MB'
      if(byteMb > 1024){
        let byteGb = byteMb/1024
        reByte = parseInt(byteGb,10) + 'GB'
      }
    }
  }

  return  reByte
    
}

export const countDownTime = (time) => {
  function format (value) {
    return Number(value) < 10 ? `0${value}` : value
  }
  var resTime = new Date(time.replace(/-/g,"/")).getTime() - new Date().getTime();   //时间差的毫秒数

   //计算出相差天数
   const days = Math.abs(Math.floor(resTime / (24*3600*1000)))

   //计算出总的小时数
   const allHours = Math.abs(Math.floor(resTime / (3600*1000)))
  
   //计算相差分钟数
    const leave2= resTime % (3600*1000)        //计算小时数后剩余的毫秒数
    const minutes=Math.abs(Math.floor(leave2/(60*1000)))
    let month = format(new Date(time.replace(/-/g,"/")).getMonth()+1)
    let day = format(new Date(time.replace(/-/g,"/")).getDate())
    let hour = format(new Date(time.replace(/-/g,"/")).getHours())
    let min = format(new Date(time.replace(/-/g,"/")).getMinutes())
    let seconds = format(new Date(time.replace(/-/g,"/")).getSeconds())
    if(days >28){
      return `${month}-${day}`
      // return `${month}-${day} ${hour}:${min}:${seconds}`
    }else if(days/7 >= 1 && -days/7 <= 4){
      return `${parseInt(days/7)}周前`
    }else if(parseInt(days/7) < 1 && days > 1){
      return `${days-1}天前`
    }else if(allHours <24 && allHours >1 ){
      return `${allHours-1}小时前`
    }else if(allHours === 1){
      return `${minutes}分钟前`
    }else if(allHours === 1 && minutes === 1){
      return `刚刚`
    }
}
export const formatNumer = (count) => {
  if(Number(count) < 9) {
    return `0${Number(count)}`
  } 
  return `${Number(count)}`
}

//节流
export const throttle = (func, delay) => {  
  let last = null
  let deferTimer = null
  return (args) => {    
    let now = new Date().getTime()    
    if (last && now < last + delay) {     
      // 未到间隔时间，清除定时器
      clearTimeout(deferTimer)
      deferTimer = setTimeout(()=> {      
        // 重新新建定时器，等待间隔时间以后置位last，执行功能函数
        last = now
        func(args)
      }, delay)
    } else {     
      // 第一次或者已超过间隔时间
      last = now
      func(args)
    }
  }
}


//获取当前日期/时间/星期
export const todayTime = () => {
        var d = new Date();
        var y = d.getFullYear();
        var m = d.getMonth()+1;
        var ds = d.getDate();
        if (ds <=9){
            ds ='0'+ds;
        }
        var h = d.getHours();
        if(h <=9){
            h = '0'+h;
        }
        var f = d.getMinutes();
        if(f <=9){
            f = '0'+f;
        }
        var s = d.getSeconds();
        if(s <=9){
            s = '0'+s;
        }
        var days = d.getDay();
        switch(days){
            case 1:
                days='星期一';
                break;
            case 2:
                days='星期二';
                break;
            case 3:
                days='星期三';
                break;
            case 4:
                days='星期四';
                break;
            case 5:
                days='星期五';
                break;
            case 6:
                days='星期六';
                break;
            case 0:
                days='星期日';
                break; 
        }
        // time = m+'月'+ds+'日'+' '+days;
        return m+'月'+ds+'日'+' '+days
}

